export const FETCH_APPROVAL_NOTIFICATIONS_REQUEST =
  "API/NOTIFICATIONS/APPROVAL_NOTIFICATION_REQUEST";
export const FETCH_APPROVAL_NOTIFICATIONS_FAILURE =
  "API/NOTIFICATIONS/APPROVAL_NOTIFICATION_REQUEST_FAILURE";
export const FETCH_APPROVAL_NOTIFICATIONS_SUCCESS =
  "API/NOTIFICATIONS/APPROVAL_NOTIFICATION_REQUEST_SUCCESS";
